
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { AlertTriangle } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        // Check if this is a moderation-related toast (by checking for keywords)
        const isModeration = (
          (title?.toString().toLowerCase().includes('content') || 
          description?.toString().toLowerCase().includes('content') ||
          title?.toString().toLowerCase().includes('guidelines') ||
          description?.toString().toLowerCase().includes('guidelines')) &&
          props.variant !== 'default'
        );
                              
        return (
          <Toast 
            key={id} 
            {...props}
            // Add extra styling for content moderation messages
            className={`${props.className || ''} ${isModeration ? 'border-red-500 bg-red-950/90' : ''}`}
          >
            <div className="grid gap-1">
              {isModeration && (
                <div className="flex items-center gap-2">
                  <AlertTriangle className="h-4 w-4 text-red-400" />
                  {title && <ToastTitle>{title}</ToastTitle>}
                </div>
              )}
              {!isModeration && title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
